import React, { useState } from 'react';
import styles from './style.module.scss';
import ButtonIcon from '../../../../components/ButtonIcon/ButtonIcon';
import CrossIcon from '../../../../assets/svg/icons/common/CrossIcon';
import useProcessorStore from '../../../../stores/processor';
import { bulkBankDeactivate } from '../../../../../api';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../../application/components/ConfirmationModal/ConfirmationModal';

const BulkAction = ({
  fetchData
}) => {

  const selectedBanks = useProcessorStore(state => state.selectedBanks);
  const setSelectedBanks = useProcessorStore(state => state.setSelectedBanks);

  const [deactivateConfirmModal, setDeactivateConfirmModal] = useState(false);
  const [activateConfirmModal, setActivateConfirmModal] = useState(false);

  const deactivateBanks = async () => {
    const toastId = toast.loading('Deactivating processors...');
    const response = await bulkBankDeactivate({
      ids: selectedBanks,
      status: 0
    });

    if (response.status) {
      toast.success(`${selectedBanks.length} processors deactivated`, { id: toastId });
      fetchData();
      setDeactivateConfirmModal(false)
      setSelectedBanks([]);
    } else {
      setDeactivateConfirmModal(false)
      toast.error(`${selectedBanks.length} processors could not be deactivated`, { id: toastId });
      setSelectedBanks([]);
    }
  }

  const activateBanks = async () => {
    const toastId = toast.loading(`${selectedBanks.length} processors activating...`);
    const response = await bulkBankDeactivate({
      ids: selectedBanks,
      status: 1
    });

    if (response.status) {
      toast.success(`${selectedBanks.length} processors activated`, { id: toastId });
      fetchData();
      setActivateConfirmModal(false)
      setSelectedBanks([]);
    } else {
      setActivateConfirmModal(false)
      toast.error(`${selectedBanks.length} processors could not be activated`, { id: toastId });
      setSelectedBanks([]);
    }
  }

  return (
    <div className={styles.container} >
      <p className={styles.label} >{selectedBanks?.length} Selected:</p>
      <div className={styles.buttonContainer} >
        <ButtonIcon
          bgColor={'transparent'}
          textColor='white'
          onClick={() => setDeactivateConfirmModal(true)}
        >
          Deactivate
        </ButtonIcon>
        <ButtonIcon
          bgColor={'transparent'}
          textColor='white'
          onClick={() => setActivateConfirmModal(true)}
        >
          Activate
        </ButtonIcon>
        <ButtonIcon 
          bgColor={'transparent'} 
          textColor='white' 
          onClick={() => {
            setSelectedBanks([]);
          }}
        >
          <CrossIcon />
        </ButtonIcon>
      </div>


      {deactivateConfirmModal && (
        <ConfirmationModal
          open={deactivateConfirmModal}
          onClose={() => setDeactivateConfirmModal(false)}
          message={"Are you sure you want to deactivate selected processors?"}
          onConfirmClick={deactivateBanks}
        />
      )}

      {activateConfirmModal && (
        <ConfirmationModal
          open={activateConfirmModal}
          onClose={() => setActivateConfirmModal(false)}
          message={"Are you sure you want to activate selected processors?"}
          onConfirmClick={activateBanks}
        />
      )}
    </div>
  )
}

export default BulkAction